import React, { useEffect } from "react";
import pipaanlogo from "../../assets/pipaanlogo.png";
import closecircle from "../../assets/images/icons/close-circle.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useState } from "react";
import viewIcon from "../../assets/images/icons/viewIcon.png";
import RedlikeIcon from "../../assets/images/icons/redlikeIcon.png";
import shareIcon from "../../assets/images/icons/shareIcon.svg";
import commentIcon from "../../assets/images/icons/commentIcon.svg";
import smileyIcon from "../../assets/images/icons/smileyIcon.png";
import profileimg from "../../assets/profile.png";
import postData from "./postdata";
import play from "../../assets/play.png";
import groupimg from "../../assets/groupimg.png";
import global from "../../assets/images/icons/global.svg";
import greenglobal from "../../assets/images/icons/green-global.png";
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import { FaArrowLeft, FaMapMarkerAlt } from 'react-icons/fa';
import Microphone from "../../assets/images/icons/microphone.png";
import Smiley from "../../assets/images/icons/Smiley.svg";
import videoicon from "../../assets/images/icons/video.svg";
import galleryicon from "../../assets/images/icons/gallery.svg";
import goliveprf from "../../assets/images/golive-prf.png";
import messagetext from "../../assets/images/icons/message-text.png";
import morecircle from "../../assets/images/icons/more-circle.svg";
import leftconnect from "../../assets/images/icons/leftconnect.png";
import Redheart from "../../assets/images/icons/red-heart.svg";
import zoomInicon from "../../assets/images/icons/search-zoom-in.png";
import zoomOuticon from "../../assets/images/icons/search-zoom-out.png";
import exporticon from "../../assets/images/icons/export.png";
import crtpostimg from "../../assets/images/crtpostimg.png";
import { groupData } from "../nestedtab/friendRequestsData";
// import demovideo from "../../assets/images/video-demo.mp4";
import ReactPlayer from "react-player";
export default function Viewpost() {
  const [playingIndex, setPlayingIndex] = useState(null);
  const [posts, setPosts] = useState([]);
  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);
  // ✅ Separate function for toggling state
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const user = { id: 1 };
  const [activeIndex, setActiveIndex] = useState(0); // Track active slide
  const [zoomLevels, setZoomLevels] = useState({}); // Store zoom levels for each image
  // const imagespost = [
  //   demovideo
  // ];
  const imagespost = [
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    // demovideo
  ];
  // const isPlaying = playingIndex === `${index}-${imgIndex}`;
  // Check if the active slide is a video
  const isVideo = imagespost[activeIndex]?.type === "video";
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state
  // Filter group data based on user.id
  const selectedGroup = groupData.find((group) => group.id === user?.id);
  const openPopup = () => {
    setIsPopupOpen(true);
  };
  const closePopup = () => {
    setIsPopupOpen(false);
  };


  // Handle sending message
  const handleSendMessage = () => {
    if (message.trim() || images.length > 0) {
      const currentTime = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      setMessages([...messages, { text: message, images, time: currentTime }]);
      setMessage('');
      setImages([]);
    }
  };
  // Handle image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const uploadedImages = files.map((file) => URL.createObjectURL(file));
    setImages([...images, ...uploadedImages]);
  };
  // Zoom In Function (only for active image)
  const zoomIn = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: Math.min((prev[activeIndex] || 1) + 0.2, 2), // Max zoom 2x
    }));
  };

  // Zoom Out Function (reset zoom)
  const zoomOut = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: 1, // Reset to normal size
    }));
  };

  return (
    <div>
      {/* Create Post */}
      <div className=" relative">
        <div className="relative">
          {/* Profile Image Inside Textarea */}

          <button
            placeholder="Share something..."
            className=""
            onClick={openPopup} // 🔹 Open popup when clicked
          >viewpost</button>
        </div>
      </div>
      {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
      {isPopupOpen && (
        <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
          <div className="border-popup bg-white rounded-lg  relative">
            <div className="flex justify-between">
              <div className="logo-popup flex items-center justify-center space-x-2 ">
                <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
              </div>
              {/* Close Button */}
              <button className="close-pop-x relative  text-gray-500" onClick={() => setIsPopupOpen(false)}
              >                                <img src={closecircle} alt="Nyawoo Logo" className="w-10 h-10" />
              </button>
            </div>
            {/* Modal Content */}
            {/* Swiper Banner with Thumbnails */}
            <div className="swiper-viewpost-slider">
              <div className="relative">
                <Swiper
                  modules={[Navigation, Pagination, Thumbs]}
                  navigation
                  pagination={{ clickable: true }}
                  thumbs={{ swiper: thumbsSwiper }} // ✅ Link with thumbnails
                  onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)} // ✅ Track active slide
                  className="rounded-lg mt-4 view-post-swiper"
                >
                  {imagespost.map((media, index) => (

                    <SwiperSlide key={index}>
                      {media.endsWith(".mp4") ? (
                        <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                          <ReactPlayer
                            url={media}
                            playing={playingIndex === index} // ✅ Play only when clicked
                            controls
                            width="auto"
                            height={imagespost.length === 1 ? "100%" : "100%"}
                            className="rounded-lg h-full video-player-swiper"
                            light={groupimg} // ✅ Thumbnail before playing
                            // playIcon={
                            //   <button
                            //     className="absolute inset-0 flex items-center justify-center bg-opacity-50 rounded-lg"
                            //     onClick={() => setPlayingIndex(index)} // ✅ Start playing when clicked
                            //   >
                            //     <img src={play} alt="Play" className="player" />
                            //   </button>
                            // }
                            playIcon={<img src={play} alt="Play" className="player" />}
                          />
                        </div>
                      ) : (
                        <img
                          src={media}
                          alt={`Slide ${index}`}
                          className="w-full h-auto max-h-[900px] object-contain  rounded-lg transition-transform duration-300"
                        />
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
                {/* Zoom Buttons (Apply to Active Image Only) */}
                <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                  <div className="flex">
                    <button onClick={zoomIn} className=" p-2 rounded-lg ">
                      {/* <img src={zoomInicon}  className="w-[16.8px] h-[16.8px]"/> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <path d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z" fill="#292D32" />
                        <path d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z" fill="#292D32" />
                      </svg>
                    </button>
                    <button onClick={zoomOut} className=" p-2 rounded-lg">
                      {/* <img src={zoomOuticon}  className="w-[16.8px] h-[16.8px]"/> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <path d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z" fill="#292D32" />
                        <path d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z" fill="#292D32" />
                        <path d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z" fill="#292D32" />
                      </svg>
                    </button>
                  </div>
                  <span className="h-5 border-r border-[#7A7A7A]"></span>
                  <button className=" p-2 rounded-lg ">
                    {/* <img src={exporticon} className="w-[16.8px] h-[16.8px]" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                      <path d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z" fill="#292D32" />
                      <path d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z" fill="#292D32" />
                      <path d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z" fill="#292D32" />
                    </svg>
                  </button>
                </div>
              </div>
              {/* Thumbnails (Hide if Active Slide is a Video) */}
              {/* Thumbnails (Hide if Active Slide is a Video) */}
              {!isVideo && (
                <Swiper
                  onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                  spaceBetween={10}
                  slidesPerView={4}
                  freeMode
                  watchSlidesProgress
                  className="mt-2"
                >
                  {imagespost.map((media, index) =>
                    !media.endsWith(".mp4") ? ( // ✅ Correct video check
                      <SwiperSlide key={index} onClick={() => thumbsSwiper.slideTo(index)}>
                        <img
                          src={media}
                          alt={`Thumbnail ${index}`}
                          className="w-full h-20 md:h-[200px] object-contain rounded-lg cursor-pointer  border border-[#B4B7C9]"
                        />
                      </SwiperSlide>
                    ) : null
                  )}
                </Swiper>
              )}
            </div>

            {/* Content Below */}
            <div className="w-full">
              {postData.length > 0 ? (
                postData.map((post, index) => (
                  <div key={index} className="share-content relative">
                    {/* Social Buttons */}
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1 gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none" className="mr-1">
                            <path d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z" stroke="#BE1F2E" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> {post.likeCount}k
                        </button>
                      </div>
                      <button className="flex items-center space-x-1 text-[#fff] share-post-cta ml-3">
                        <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                      </button>
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img src={post.profileimg} alt="Profile" className="w-full h-full object-cover" />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">{post.username || "Unknown User"}</p>
                          <p className="flex text-sm text-[#747474]">
                            {post.date} |
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex ">
                        <button className="bg-[#095228] text-[#FFFFFF] follow-cta">Follow</button>

                        {/* Public Dropdown */}
                        <div className="view-sharepost-drpdown">
                          <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button>

                          {/* ✅ Show dropdown only if isOpen is true */}
                          {isOpen && (
                            <div className="absolute  bg-white shadow-md rounded-md w-40 p-2">
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <p className="my-4 ml-[80px]">{post.content}</p>



                    {/* Comment Section */}
                    <div class="flex items-center relative">

                      <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
                        {/* Profile Image Upload */}
                        <label className="relative cursor-pointer">

                          <img
                            src={post.profileimg}
                            alt={post.groupName}
                            className="w-[80px] h-[70px] rounded-full object-cover "
                          />
                        </label>
                      </div>
                      <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
                        <div class="flex space-x-2 ml-3 py-4 microphone-sm">
                          <button class="text-gray-400"><img
                            src={Microphone}
                            alt={post.groupName}
                            className=""
                          /></button>
                        </div>
                        {/* <input
                                          value={message}
                                          onChange={(e) => setMessage(e.target.value)}
                                          placeholder="Add a comment"
                                          class="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                                        /> */}
                        <input
                          type="Add a comment"
                          className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                        />
                        <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
                          <button class="px-3 smiley">
                            <img
                              src={Smiley}
                              alt={post.groupName}
                              className=""
                            />
                          </button>
                          <label className="cursor-pointer">
                            <img
                              src={galleryicon}
                              alt={post.groupName}
                              className=""
                            />
                            <input
                              type="file"
                              multiple
                              accept="image/*"
                              className="hidden"
                            />
                          </label>
                          <button class="px-3">
                            <img
                              src={videoicon}
                              alt={post.groupName}
                              className=""
                            />
                          </button>
                        </div>
                        <button class="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3">Send</button>

                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No posts available.</p>
              )}
            </div>
            {/* CHAT CONTENT AREA */}
            <div className="dashboard w-full  flex mx-auto">
              <main className="flex w-full">
                <div className="flex flex-col  w-full">
                  {/* CHAT FOOTER (INPUT AREA) */}
                  <CommentSection />
                </div>
              </main>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


const CommentSection = () => {
  const [comments, setComments] = useState([
    {
      id: 1,
      name: "Ralph Edwards",
      avatar: profileimg,
      text: "This is the first comment",
      time: "10:30 AM",
      likes: 3,
      replies: [],
    },
    {
      id: 2,
      name: "Jane Cooper",
      avatar: profileimg,
      text: "Another comment here",
      time: "11:00 AM",
      likes: 2,
      replies: [],
    },
  ]);

  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState({});
  const [showReplyBox, setShowReplyBox] = useState({});

  // Function to add a new comment
  const handleAddComment = () => {
    if (!commentText.trim()) return;
    const newComment = {
      id: Date.now(),
      name: "Current User",
      avatar: profileimg,
      text: commentText,
      time: new Date().toLocaleTimeString('en-US', { hour12: true }),
      likes: 0,
      replies: [],
    };
    setComments([...comments, newComment]);
    setCommentText("");
  };

  // Function to add a reply
  const handleAddReply = (commentId) => {
    if (!replyText[commentId]?.trim()) return;
    const newReply = {
      id: Date.now(),
      name: "Current User",
      avatar: profileimg,
      text: replyText[commentId],
      time: new Date().toLocaleTimeString('en-US', { hour12: true }),
      likes: 0,
    };
    setComments(
      comments.map((comment) =>
        comment.id === commentId
          ? { ...comment, replies: [...comment.replies, newReply] }
          : comment
      )
    );
    setReplyText({ ...replyText, [commentId]: "" });
    setShowReplyBox({ ...showReplyBox, [commentId]: false });
  };

  return (
    <div className="p-4">


      {/* Display Comments and Replies */}
      {comments.map((comment) => (
        <div key={comment.id} className="mb-4 border-b pb-3 relative">

          <div className="flex gap-3">
            <img
              src={profileimg}
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex-1">
              <div className="bg-[#FEFDEB] p-3 rounded-[20px]">
                <div className="flex justify-between">
                  <p className="font-semibold">{comment.name}</p>
                  <span className="text-[#9397AD] font-[14px]">{comment.time}</span>
                </div>
                <p className="text-gray-700">{comment.text}</p>
                <div className="flex items-center justify-end text-xs text-gray-500 mt-1">

                  <button
                    className="ml-4 mr-2 text-[#095228] font-medium "
                    onClick={() =>
                      setShowReplyBox({
                        ...showReplyBox,
                        [comment.id]: !showReplyBox[comment.id],
                      })
                    }
                  >
                    Reply
                  </button>
                  <div className="flex items-center space-x-1">
                    {/* ✅ Pass 'reply' instead of 'post' */}
                    <LikeButton reply={comment} />
                    <span className="ml-2 flex items-center"><img src={messagetext} /> &nbsp;{comment.replies.length}</span>
                  </div>
                </div>
              </div>
              {/* Reply Input Box */}
              {showReplyBox[comment.id] && (
                <div className="flex items-center mt-2">

                  <input
                    type="text"
                    value={replyText[comment.id] || ""}
                    onChange={(e) =>
                      setReplyText({ ...replyText, [comment.id]: e.target.value })
                    }
                    className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                    placeholder="Write a reply..."
                  />
                  <button
                    onClick={() => handleAddReply(comment.id)}
                    className="ml-2 bg-[#095228] text-[white] px-5 py-2 rounded-[20px]"
                  >
                    Reply
                  </button>
                </div>

              )}
            </div>

          </div>

          {/* Render Replies */}
          <div className="ml-14 mt-3">
            {comment.replies.map((reply) => (
              <div key={reply.id} className="flex gap-3 mt-2 relative">
                <img
                  src={leftconnect}
                  className="absolute left-[-50px] z-99 top-[-51px] h-full"
                />
                <img
                  src={profileimg}
                  alt="User Avatar"
                  className="w-8 h-8 rounded-full"
                />
                <div className="flex-1">
                  <div className="bg-green-100 p-3 rounded-lg">
                    <div className="flex justify-between">
                      <p className="font-semibold">{reply.name}</p>
                      <span className="text-[#9397AD] text-[14px]">{reply.time}</span>
                    </div>
                    <p className="text-gray-700">{reply.text}</p>
                    {/* ✅ Pass 'reply' instead of 'post' */}
                    <div className="flex items-end justify-end space-x-1">
                      <LikeButton reply={reply} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {/* Input for adding a new comment */}
      <div className="flex items-center mb-4">




        <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
          {/* Profile Image Upload */}
          <label className="relative cursor-pointer">

            <img
              src={profileimg}
              className="w-[80px] h-[70px] rounded-full object-cover "
            />
          </label>
        </div>


        <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
          <div class="flex space-x-2 ml-3 py-4 microphone-sm">

          </div>
          {/* <input
                                          value={message}
                                          onChange={(e) => setMessage(e.target.value)}
                                          placeholder="Add a comment"
                                          class="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
                                        /> */}
          <input
            type="Add a comment"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            className="flex-1 min-w-0 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
          />
          <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
            <button class="px-3 smiley">
              <img
                src={Smiley}
                className=""
              />
            </button>

          </div>
          <button class="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3" onClick={handleAddComment}>Send</button>
        </div>
      </div>
    </div>
  );
};
// ✅ Fix: LikeButton is properly structured with useState
const LikeButton = ({ reply }) => {
  const [liked, setLiked] = useState(false);

  return (
    <div className="mr-2">
      <span
        className="flex items-center space-x-1 cursor-pointer"
        onClick={() => setLiked(!liked)}
      >
        <img src={liked ? Redheart : RedlikeIcon} alt="Like Icon" className={` transition duration-300 ${liked ? 'w-6 h-6' : 'w-6 h-5'}`} />
        <span>{reply?.likes}</span>
      </span>
    </div>
  );
};